package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_itinerary_domain_di_ItineraryServiceUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.itinerary.domain.use_case.UpdateItineraryServiceUseCase(itineraryRepository=get(),toastManager=get()) } 
}
public val com.essntl.features.itinerary.domain.di.ItineraryServiceUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_itinerary_domain_di_ItineraryServiceUseCaseModule
